"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TemplateItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _reactI18next = require("react-i18next");
var _globalComponentsLibrary = require("global-components-library");
var _MessageInput = _interopRequireDefault(require("../../common/MessageInput/MessageInput"));
var _IconButton = _interopRequireDefault(require("../../common/IconButton/IconButton"));
var _formatters = require("../../../utils/formatters");
var _FileSlider = _interopRequireDefault(require("../../MediaViewer/Slider/FileSlider"));
var _RecordButton = _interopRequireDefault(require("../../MultimediaMessages/RecordButton"));
require("./ChatFooter.scss");
var _hooks = require("../../../utils/hooks");
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var replaceTemplatesData = function replaceTemplatesData(templates, contact, t, agent) {
  var date = new Date();
  var currentHr = date.getHours();
  var typeofGreeting = '';
  if (currentHr < 12) {
    typeofGreeting = 'morning';
  } else if (currentHr < 18) {
    typeofGreeting = 'afternoon';
  } else {
    typeofGreeting = 'night';
  }
  return templates ? templates.map(function (template) {
    return _objectSpread(_objectSpread({}, template), {}, {
      text: template.text.replace('%var1%', (0, _formatters.formatDateLong)(date)).replace('%var2%', t('time')).replace('%var3%', agent.username).replace('%var4%', agent.name).replace('%var5%', t("greetings.".concat(typeofGreeting))).replace('%var6%', contact.name)
    });
  }) : [];
};
var ChatFooter = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var templates = _ref.templates,
    disabled = _ref.disabled,
    onSendResponse = _ref.onSendResponse,
    contact = _ref.contact,
    agent = _ref.agent,
    media = _ref.media,
    mediaType = _ref.mediaType,
    selectedAttachment = _ref.selectedAttachment,
    onSelectAttachment = _ref.onSelectAttachment,
    onDeleteAttachment = _ref.onDeleteAttachment,
    onUploadAttachments = _ref.onUploadAttachments,
    onLoading = _ref.onLoading,
    maxImgToSend = _ref.maxImgToSend,
    onDialog = _ref.onDialog;
  var _useTranslation = (0, _reactI18next.useTranslation)(['chat', 'mail-editor']),
    t = _useTranslation.t;
  var formattedTemplates = replaceTemplatesData(templates, contact, t, agent);
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    response = _useState2[0],
    setResponse = _useState2[1];
  var _useError = (0, _hooks.useError)(),
    _useError2 = _slicedToArray(_useError, 3),
    error = _useError2[0],
    showError = _useError2[1],
    toggleError = _useError2[2];
  var areaRef = (0, _react.useRef)();
  var inputRef = (0, _react.useRef)();
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      focus: function focus() {
        areaRef.current.focus();
      }
    };
  });
  var handleSend = function handleSend() {
    if (response.length > 0) {
      onSendResponse(response);
      setResponse('');
    }
    if (media.length > 0) {
      onSendResponse(media);
      // setAttachment([]);
    }
  };

  (0, _react.useEffect)(function () {
    if (response.includes('[Time]') || response.includes('[Hora]')) {
      setResponse(response.replace('[Time]', (0, _formatters.formatTimeLong)(new Date())).replace('[Hora]', (0, _formatters.formatTimeLong)(new Date())));
    }
  }, [response]);
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    filtered = _useState4[0],
    setFiltered = _useState4[1];
  var onDeleteAttachmentHandle = function onDeleteAttachmentHandle(current) {
    onDeleteAttachment(current.url);
  };
  var getFiles = (0, _hooks.useFileHandler)(mediaType, maxImgToSend, showError);
  var onAttachFile = function onAttachFile(e) {
    if (e.target && (0, _lodash.size)(e.target.files) > 0) {
      onLoading(true);
      try {
        onUploadAttachments(getFiles(e.target.files));
        inputRef.current.value = '';
      } catch (err) {
        console.error(err);
        onLoading(false);
      }
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-chat-footer"
  }, !media || media.length === 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    icon: "list",
    large: true,
    id: "uin-templates-icon",
    disabled: disabled
  }), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: "uin-templates-icon"
  }, t('templates')), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledPopover, {
    disabled: disabled,
    className: "uin-templates-popover",
    target: "uin-templates-icon",
    placement: "top-start",
    fade: false,
    trigger: "legacy"
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.PopoverHeader, null, /*#__PURE__*/_react["default"].createElement("span", null, t('templates')), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.FilterInput, {
    placeholder: t('search-placeholder'),
    data: formattedTemplates,
    filterBy: ['title', 'text'],
    onChange: setFiltered,
    ignoreCase: true
  })), /*#__PURE__*/_react["default"].createElement(_reactstrap.PopoverBody, null, filtered.map(function (template, i) {
    return /*#__PURE__*/_react["default"].createElement(TemplateItem, _extends({
      key: i,
      tabIndex: i + 1
    }, template, {
      onClick: function onClick() {
        return setResponse(template.text);
      }
    }));
  }))), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    secondary: true,
    large: true,
    icon: "clip-right",
    id: "uin-attach-btn",
    disabled: disabled,
    onClick: function onClick() {
      inputRef.current.click();
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: "uin-attach-btn",
    innerClassName: "long"
  }, /*#__PURE__*/_react["default"].createElement("p", null, t('mail-editor:attach'))), /*#__PURE__*/_react["default"].createElement("input", {
    type: "file",
    multiple: true,
    className: "input",
    ref: inputRef,
    onChange: onAttachFile
  }), /*#__PURE__*/_react["default"].createElement(_MessageInput["default"], {
    onFocus: onDialog,
    ref: areaRef,
    disabled: disabled,
    maxChars: 500,
    value: response,
    onChange: setResponse,
    onEnter: handleSend,
    placeholder: t('response-placeholder')
  })) : /*#__PURE__*/_react["default"].createElement(_FileSlider["default"], {
    media: media,
    selected: selectedAttachment,
    onSelect: onSelectAttachment,
    onDeleteAttachment: onDeleteAttachmentHandle,
    onUploadAttachments: onUploadAttachments,
    mediaType: mediaType,
    maxImgToSend: maxImgToSend
  }), response.length > 0 || media.length > 0 ? /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    icon: "send",
    large: true,
    id: "uin-send-btn",
    onClick: handleSend,
    disabled: disabled
  }) : /*#__PURE__*/_react["default"].createElement(_RecordButton["default"], {
    disabled: disabled,
    onAudioURL: onUploadAttachments
  })), response.length > 0 && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: "uin-send-btn",
    innerClassName: "long"
  }, /*#__PURE__*/_react["default"].createElement("p", null, t('send-enter')), /*#__PURE__*/_react["default"].createElement("p", null, t('newline-enter'))), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.DialogBox, _extends({}, error, {
    toggle: toggleError,
    accept: t('errorFormat.attachErrorCommit')
  })));
});
var TemplateItem = exports.TemplateItem = function TemplateItem(_ref2) {
  var title = _ref2.title,
    text = _ref2.text,
    onClick = _ref2.onClick,
    tabIndex = _ref2.tabIndex;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-template-item",
    tabIndex: tabIndex,
    onClick: onClick,
    id: 'uin-template-item-' + tabIndex
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon text"
  }), /*#__PURE__*/_react["default"].createElement("section", {
    className: "uin-template-content"
  }, /*#__PURE__*/_react["default"].createElement("header", null, title), /*#__PURE__*/_react["default"].createElement("p", null, text))), text.length > 30 && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: 'uin-template-item-' + tabIndex,
    delay: {
      show: 400,
      hide: 50
    },
    boundariesElement: "window"
  }, text));
};
ChatFooter.defaultProps = {
  media: []
};
var _default = exports["default"] = ChatFooter;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/ConversationView/ChatView/ChatFooter.js
// module id = 1400
// module chunks = 0